<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content"
        v-loading="loadingStaus"
        :element-loading-text="loadingText">
        <el-row :gutter="48">
          <el-form ref="companyForm" :model="formData" :rules="rules" label-width="100px">
            <el-col :span="18">
              <el-form-item v-for="(item,index) in formList" :key="index" :label="item.label" :prop="item.props">
                <el-input v-if="item.type=='select'" disabled :value="item.propsData[formData[item.props]]"></el-input>
                <el-input v-else disabled :value="formData[item.props]"></el-input>
              </el-form-item>
              <el-form-item label="服务公司" prop="channel_name">
                <el-input disabled :value="formData.channel_name"></el-input>
              </el-form-item>
              <el-form-item label="任务类型" prop="category_name">
                <el-input disabled :value="formData.category_name"></el-input>
              </el-form-item>
              <el-form-item label="绑定岗位" prop="task_ids">
                <el-select
                  v-model="formData.task_ids"
                  multiple
                  filterable
                  clearable
                  collapse-tags
                  placeholder="请选择绑定岗位"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in taskOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="任务描述" prop="mission_content" v-if="formData.mission_content">
                <el-input disabled type="textarea" rows="6" :value="formData.mission_content"></el-input>
              </el-form-item>
              <el-form-item label="状态" prop="birthday">
                <el-input disabled type="input" :value="formData.status | TransactionStatus"></el-input>
              </el-form-item>
              <el-form-item label="审核状态" prop="mobile">
                <el-input disabled type="input" :value='formData.examine_status=="1"?"审核成功":formData.examine_status=="2"?"审核失败":"审核中"'></el-input>
              </el-form-item>
              <el-form-item label="失败原因" v-if="formData.examine_status==2" prop="mobile">
                <el-input disabled type="textarea" rows="4" :value="formData.examine_reason"></el-input>
              </el-form-item>
              <el-form-item label="合作邀请码" prop="mobile" v-if="formData.examine_status==1">
				<img :src="formData.code_url" @click="showImage(formData.code_url)" class="QR-code" v-if="formData.code_url"/>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
        <div class="page-footer">
          <el-button
            type="primary"
            :loading="saveLoading"
            @click="saveTaskBinding"
          >
            保存
          </el-button>
        </div>
         <!-- 预览图片弹框 -->
        <el-dialog
          :title="'预览图片'"
          :visible.sync="dialogVisible"
          :modal="false"
          :width="'35%'"
        >
          <div class="block" v-if="dialogVisible">
            <img :src="this.imageUrl" class="preview">
          </div>
        </el-dialog>
      </div>
    </PageHeaderLayout>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import UploadFile from "@/components/UploadFile";
import { mapGetters } from 'vuex'
import {SALARY_TYPE_TEXT} from '@/utils/utils.js'
export default {
  components: {
    PageHeaderLayout,
    UploadFile,
  },
  data() {
    return {
      formList: [
        {
          label: "任务名称",
          props: "title",
        },
        {
          label: "行业类型",
          props: "recruit_type_name",
        },
        {
          label: "工作地点",
          props: "all_address",
        },
        {
          type: 'select',
          label: "结算方式",
          props: "salary_type",
          propsData: SALARY_TYPE_TEXT
        },
        {
          label: "用工人数",
          props: "person_num",
        },
        {
          label: "最低薪资",
          props: "min_salary",
        },
        {
          label: "最高薪资",
          props: "max_salary",
        },
        {
          label: "学历要求",
          type: "select",
          props: "min_qualification",
          propsData: {
            0:"不限",
            1:"小学",
            2:"初中",
            3:"高中",
            4:"大专",
            5:"本科及以上",
          }
        },
      ],
      dialogVisible: false,
      activeTab: '0',
      hearTitle: '基本设置',
      loadingStaus: true,
      loadingText: '正在提交中……',
      formDisabled: false,
      billId:0, // 公司id，0表示创建，非零为编辑
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      // 分类列表
      categoryList:[],
      openapiList:[],
      // 标签
      categoryLabelList:[],
      // 已选中的分类列表，用于cascader组件选中效果
      selectedList:[],
      // 已选中标签
      selectedLabelList:[],
      // 公司基本信息表单结构
      formData:{},
      // 已上传图片列表
      uploadFileList:[],
      // 公司基本信息规则
      rules: {
        name: [
          {required: true, message: '输入公司名称', trigger: 'blur' },
        ],
        file_url: [
          {required: true, message: '输入文件名称', trigger: 'blur' },
        ]
      },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
      imageUrl: '',//图片地址
      taskOptions: [],
      saveLoading: false,
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
  },
  methods: {
    /* 预览图片 */
    showImage(data) {
      this.dialogVisible = true;
      this.imageUrl = data;
    },
    normalizeTaskIds(taskIds) {
      if (Array.isArray(taskIds)) {
        return taskIds.map(item => item === null || item === undefined ? '' : String(item)).filter(Boolean)
      }
      if (typeof taskIds === 'string') {
        return taskIds
          .split(/[,，、]/)
          .map(item => item.trim())
          .filter(Boolean)
      }
      if (taskIds || taskIds === 0) {
        return [String(taskIds)]
      }
      return []
    },
    async getQuickRecruitPostList() {
      const res = await this.$api.recruitTaskList({
        page_size: 0,
        current_page: 0
      })
      const taskList = res.data || []
      this.taskOptions = taskList.map((item) => ({
        label: item.recruit_post || item.title || String(item.id),
        value: String(item.id),
      }))
    },
    // 初始化公司基本信息
    async init() {
      let url = this.$route.path
      let urlSlashCount=url.split('/').length
      this.action = url.split('/')[urlSlashCount-1].toLowerCase()
      this.formDisabled = (this.action === 'view') ? true : false
      console.log("action -> ", this.formDisabled)
      if (this.$route.params.customer_id) {
        this.id = this.$route.params.customer_id
      }
      if (this.id) {
        let {info} = await this.$api.getCustomerInfo(this.id)
        console.log("formData", info)
        this.formData = info
      }
      this.formData = {
        ...this.formData,
        task_ids: this.normalizeTaskIds(this.formData.task_ids),
      }
    },
    async saveTaskBinding() {
      if (!this.formData.id) {
        this.$message.error('未获取到岗位id')
        return
      }
      this.saveLoading = true
      try {
        await this.$api.updateMissionTaskBinding({
          id: this.formData.id,
          task_ids: this.formData.task_ids || [],
        })
        this.$message.success('保存成功')
        this.$router.go(-1)
      } finally {
        this.saveLoading = false
      }
    },
    //返回上一页
    goBack() {
      this.$router.push({ path: "/mission_center" });
    }
  },
  async mounted() {
    this.formData = {
      ...this.$route.params,
      task_ids: this.normalizeTaskIds(this.$route.params.task_ids),
    };
    this.loadingStaus = true
    try {
      await this.getQuickRecruitPostList()
      await this.init()
    } finally {
      this.loadingStaus = false
    }
  },
}
</script>

<style lang="stylus" scoped>
  .content-left
    min-height 640px
    border-right 1px solid  #e8e8e8
    .el-cascader
      display block
      width 320px
  .back-btn
    position absolute;
    right 50px;
    top 150px;
  .content-right
    .right-button
      border-top 1px solid #e8e8e8e8
      padding 12px 12px
    .el-form-item__label
      float none
      display inline-block
      text-align left
      padding 0 0 10px 0
    .el-form-item__content
      margin-left 0px !important
      .el-checkbox-group
        margin-top -12px
  .preview
    width: 100%
  .idImg
    width: 100px
    cursor: pointer
	
.QR-code {
  width: 250px;
  height: 250px;
}

.page-footer
  margin-top 24px
  text-align center
</style>
